import { render, staticRenderFns } from "./bookingHistoryDialog.vue?vue&type=template&id=5dc74fdc&scoped=true"
import script from "./bookingHistoryDialog.vue?vue&type=script&lang=js"
export * from "./bookingHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./bookingHistoryDialog.vue?vue&type=style&index=0&id=5dc74fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc74fdc",
  null
  
)

export default component.exports